import { Component, Input } from "@angular/core";
import { LayoutService } from "../../services/layout.service";
import { HttpClient } from "@angular/common/http";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-svg-icon",
  templateUrl: "./svg-icon.component.html",
  styleUrls: ["./svg-icon.component.scss"],
})
export class SvgIconComponent {
  @Input()
  public name?: string;
  public svgIcon: any;

  @Input("icon") public icon;
  @Input() width: string = '20px';
  @Input() height: string = '20px';
  @Input()iconColor: any;
  public iconValue;

  constructor(
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer,
    // public layOut: LayoutService
    ) {
  }

  getSvgType() {
    return document.getElementsByClassName("sidebar-wrapper")[0].getAttribute("icon") == "stroke-svg";
  }

  public ngOnChanges(): void {
    if (!this.name) {
      this.svgIcon = '';
      return;
    }
    this.httpClient
      .get(`assets/svg/${this.name}.svg`, { responseType: 'text' })
      .subscribe(value => {
         const updatedSvg = value.replace('<svg', `<svg width="${this.width}" height="${this.height}" fill="${this.iconColor}"`);

        this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(updatedSvg);
      });
  }
}
